import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';

import { GET_FINANCIAL_CONSENT_DETAILS_URL, GET_FINANCIAL_CONSENT_SUMMARY_URL } from './URL';

const SECURE_ACCESS_REDIRECTION_URL_CODE = {
  [GET_FINANCIAL_CONSENT_SUMMARY_URL]: SERVICE_CATALOG_CODE.financialConsents,
  [GET_FINANCIAL_CONSENT_DETAILS_URL]: SERVICE_CATALOG_CODE.financialConsents,
};

export { SECURE_ACCESS_REDIRECTION_URL_CODE };
